import { __assign, __read, __spreadArray, __values } from "tslib";
var isStringArray = function (value) {
    return Array.isArray(value) && value.every(function (item) { return typeof item === 'string'; });
};
var isLevel = function (value) {
    return value === 'light' || value === 'medium' || value === 'conservative';
};
/** Returns a copy. The caller supplies a validator for the target DOM's CSS syntax. */
export var validatePrivacySelectors = function (config, validate, onInvalid) {
    var e_1, _a;
    var result = __assign({}, config);
    try {
        for (var _b = __values(['blockSelector', 'maskSelector', 'unmaskSelector']), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = config[key];
            var selectors = typeof value === 'string' ? [value] : value !== null && value !== void 0 ? value : [];
            var valid = selectors.filter(function (selector) {
                try {
                    validate(selector);
                    return true;
                }
                catch (_a) {
                    if (!onInvalid)
                        throw new Error("Invalid privacy selector: ".concat(selector));
                    onInvalid(selector);
                    return false;
                }
            });
            result[key] = valid.length ? valid : undefined;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
};
/** Strict remote-policy boundary. Invalid policy throws; callers must not start capture on failure. */
export var parsePrivacyConfig = function (value, validateSelector) {
    var e_2, _a;
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('Invalid privacy config');
    var input = value;
    var config = {};
    if (input.defaultMaskLevel !== undefined) {
        if (!isLevel(input.defaultMaskLevel))
            throw new Error('Invalid defaultMaskLevel');
        config.defaultMaskLevel = input.defaultMaskLevel;
    }
    try {
        for (var _b = __values(['blockSelector', 'maskSelector', 'unmaskSelector', 'maskAttributes']), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var entry = input[key];
            if (entry === undefined)
                continue;
            if (key === 'blockSelector' && typeof entry === 'string') {
                config[key] = entry;
                continue;
            }
            if (!isStringArray(entry))
                throw new Error("Invalid ".concat(key));
            config[key] = __spreadArray([], __read(entry), false);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    if (input.urlMaskLevels !== undefined) {
        if (!Array.isArray(input.urlMaskLevels))
            throw new Error('Invalid urlMaskLevels');
        config.urlMaskLevels = input.urlMaskLevels.map(function (rule) {
            if (!rule || typeof rule !== 'object')
                throw new Error('Invalid URL mask rule');
            var entry = rule;
            if (typeof entry.match !== 'string' || !entry.match.trim() || !isLevel(entry.maskLevel)) {
                throw new Error('Invalid URL mask rule');
            }
            return { match: entry.match, maskLevel: entry.maskLevel };
        });
    }
    return validatePrivacySelectors(config, validateSelector);
};
//# sourceMappingURL=validation.js.map